import { ArrowRightIcon } from '@heroicons/react/24/outline'
import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { useShallow } from 'zustand/react/shallow'

import { Organization, VerifySessionResponse } from '@ui/interfaces'
import axios from '@ui/lib/api/axiosHelper'
import { useAuth } from '@ui/providers/AuthProvider'
import { useInstanceStore } from '@ui/stores'
import clsx from 'clsx'

export const ExistingOrganizations = () => {
  const [searchParams] = useSearchParams()
  const setup = searchParams.get('setup')

  const { currentMember } = useAuth()

  const [organizations, setOrganizations] = useState<Organization[]>([])

  const { setSelectedInstanceKey, resetStore } = useInstanceStore(
    useShallow((state) => ({
      setSelectedInstanceKey: state.setSelectedInstanceKey,
      resetStore: state.resetStore,
    }))
  )

  const navigate = useNavigate()
  const auth = useAuth()

  useEffect(() => {
    axios
      .get('/v1/organizations')
      .then((response) => {
        setOrganizations(response.data)
        console.log(response)
      })
      .catch((error) => {
        console.log(error)
      })
  }, [])

  const handleOrganizationChange = (newOrganization: Organization) => {
    // Prevent the placeholder from being considered a valid selection
    resetStore()

    auth.setOrganization(newOrganization.id, (err, response?: VerifySessionResponse) => {
      if (err) {
        console.error('Error setting organization:', err)
        return
      }

      if (!response) {
        console.error('No response from setting organization')
        return
      }

      if (!response.organization || !response.instance) {
        console.error('No organization or instance in response')
        return
      }

      const { organization, instance } = response
      setSelectedInstanceKey(instance.connect_key)

      if (setup && organization.slug !== 'datable-demo') {
        navigate(`/setup`)
      } else {
        instance
          ? navigate(`/instances/${instance.connect_key}/explore/events`)
          : navigate(`/manage/${organization.id}/instances`)
      }
    })
    // Additional logic here if needed
  }

  return (
    <div className="w-[37.5rem] rounded-md border border-gray-200">
      <div className="border-b border-gray-200 p-4">
        <p className="text-xs text-gray-900">
          Team for <span className="font-semibold">{currentMember?.email}</span>
        </p>
      </div>

      <div className="max-h-[25rem] overflow-y-auto">
        {organizations.length > 0 ? (
          organizations.map((org) => (
            <div
              key={org.id}
              onClick={() => handleOrganizationChange(org)}
              className={clsx(
                'flex cursor-pointer items-center justify-between border-b border-gray-200 p-4 last:border-b-0 hover:bg-gray-50',
                'transition-all duration-300 ease-in-out'
              )}>
              <p className="text-sm font-semibold text-gray-900">{org.name}</p>

              <ArrowRightIcon className="h-5 w-5 text-gray-800" />
            </div>
          ))
        ) : (
          <div className="flex cursor-pointer items-center justify-between border-b border-gray-200 p-4 transition-all duration-300 ease-in-out last:border-b-0 hover:bg-gray-50">
            <p className="text-sm text-gray-900">No organizations found</p>
          </div>
        )}
      </div>
    </div>
  )
}
